import { Component, EventEmitter, inject, OnInit, Output, NgZone } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AuthenticationService } from '../../../core/services/authentication.service';

@Component({
  selector: 'app-login-modal',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterModule],
  templateUrl: './login.html',
  styleUrl: './login.scss'
})
export class LoginComponent implements OnInit {
  @Output() closeModal = new EventEmitter<void>();
  loginForm: FormGroup;
  isLoading = false;
  errorMessage = '';
  showPassword: boolean = false;
  private readonly fb = inject(FormBuilder);
  private readonly router = inject(Router);
  private readonly authService = inject(AuthenticationService);
  private readonly ngZone = inject(NgZone);

  constructor() {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required]],
      password: ['', Validators.required],
      rememberMe: [false]
    });
  }

  ngOnInit(): void { }

  onSubmit(): void {
    if (this.loginForm.invalid) {
      this.errorMessage = 'Please fill in all required fields';
      return;
    }

    this.isLoading = true;
    this.errorMessage = '';

    const { email, password } = this.loginForm.value;

    this.authService.login({ userName: email, password }).subscribe({
      next: (response: any) => {
        this.ngZone.run(() => {
          this.isLoading = false;
          this.closeModal.emit();

          const role = this.authService.getUserRole().toLowerCase();

          if (role === 'admin') {
            this.router.navigate(['/admin']);
          } else if (role === 'student') {
            this.router.navigate(['/student']);
          } else {
            this.router.navigate(['/home']);
          }
        });
      },
      error: (err: any) => {
        this.ngZone.run(() => {
          this.isLoading = false;
          if (err.status === 401) {
            this.errorMessage = 'Invalid username or password.';
          } else {
            this.errorMessage = err.error?.message || 'Login failed. Please try again.';
          }
        });
      },
    });
  }

  onOverlayClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.closeModal.emit();
    }
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }
}
